// vue
import Vue from "vue";
import Router from "vue-router";
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
// 使用路由
Vue.use(Router);

// 网站前台
import { webLayoutRouter } from "./web/layout";

// 登陆退出
import {
  adminLoginRouter,
  adminLogoutRouter,
  requireAdminAuth
} from "./admin/login";
// 管理后台
import {
  adminLayoutRouter,
  adminDashboardRouter,
  adminChildrenRouter
} from "./admin/layout";

const router = new Router({
  mode: 'history', // 开启 history 模式，记得配置 http 服务改写规则
  // base: __dirname,
  routes: [
    adminLoginRouter, // 管理员登陆
    adminLogoutRouter, // 管理员注销
    {
      // 网站前台
      path: webLayoutRouter.path,
      name: webLayoutRouter.name,
      component: webLayoutRouter.component,
      children: [
        //  新闻列表页
        {
          path: '/news.html',
          name: 'NewsList',
          meta: {
            auth: true
          },
          component: () => import('../web/layout/NewsList.vue'),
        },
        //  新闻详情页
        {
          path: '/news/:id.html',
          name: 'NewsInfo',
          props: true,
          component: () => import('../web/layout/NewsInfo.vue'),
        },
      ]
    },
    // {
    //   path: '/news/:id.html',
    //   name: 'NewsInfo',
    //   props: true,
    //   component: () => import('../web/layout/NewsInfo.vue'),
    // },
    // 新闻列表页
    // {
    //   path: '/news.html',
    //   name: 'NewsList',
    //   meta: {
    //     auth: true
    //   },
    //   component: () => import('../web/layout/NewsList.vue'),
    // },
    {
      // 管理后台
      path: adminLayoutRouter.path,
      name: adminLayoutRouter.name,
      component: adminLayoutRouter.component,
      redirect: adminDashboardRouter,
      beforeEnter: requireAdminAuth,
      children: adminChildrenRouter
    },


  ]
});
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    config.isNoNewsPage = true
  } else {
    config.isNoNewsPage = false
  }
  // 在路由切换前执行的逻辑
  console.log('路由切换前');
  next(); // 必须调用 next() 函数，否则路由不会继续切换
});

router.afterEach((to, from) => {
  // 在路由切换后执行的逻辑
  console.log('路由切换后');
});


// 输出路由
export default router;
